import React from "react";
import StackComponent from "../../components/Base/StackComponent";
import Navbar from "./Navbar";
import { useLocation } from "react-router";
import styled from "@emotion/styled";
import Footer from "./Footer";

const StyledStack = styled(StackComponent)(({ theme }) => ({
  "& .css-hwnj0i-MuiStack-root > *": {
    width: "50%",
  },
  "& .css-hwnj0i-MuiStack-root > *": {
    width: "100%",
  },
  "& .css-m67tbb-MuiStack-root": {
    maxHeight: "80vh",
  },
}));

const LandingLayout = ({ children, styleOverrides }) => {
  const location = useLocation();
  return (
    <StackComponent
      direction="column"
      sx={{
        width: "100%",
        minHeight: "100vh",
        position: "relative",
        ...styleOverrides,
      }}
    >
      <Navbar />
      {location.pathname.includes("public") ? (
        <StyledStack
          alignItems="center"
          direction="column"
          sx={{ p: "50px", pt: "100px" }}
        >
          {children}
        </StyledStack>
      ) : (
        <>{children}</>
      )}
      <Footer />
    </StackComponent>
  );
};

export default LandingLayout;
